import { normalizeToken } from "./searchTokens";

// Mirrors MIN_WORD_LENGTH in functions/timeCapsuleSearchTokens.js. Shorter
// words are never stored, so asking for one would always return nothing.
export const MIN_SEARCH_WORD_LENGTH = 3;

// Mirrors MAX_PREFIX_LENGTH in functions/timeCapsuleSearchTokens.js.
const MAX_PREFIX_LENGTH = 8;

const WORD_SPLIT = /[\s._-]+/;

/**
 * The single token the server can be asked for, plus the words the caller must
 * still check in memory.
 *
 * Firestore allows one array-contains per query, so the longest word wins — a
 * longer prefix matches fewer documents. It is truncated to the stored prefix
 * ceiling because tokens hold whole words and prefixes 3-8 and nothing in
 * between: querying "photograph" verbatim would match neither "photography"
 * nor any stored prefix.
 */
export function toCapsuleSearchTerm(raw = "") {
  const input = typeof raw === "string" ? raw : "";
  const normalized = normalizeToken(input);
  const words = normalized
    .split(WORD_SPLIT)
    .filter((word) => word.length >= MIN_SEARCH_WORD_LENGTH);

  if (words.length === 0) {
    return { serverTerm: "", words: [], normalized };
  }

  const longest = words.reduce(
    (best, word) => (word.length > best.length ? word : best),
    words[0]
  );

  return {
    serverTerm: longest.slice(0, MAX_PREFIX_LENGTH),
    words,
    normalized,
  };
}
